export const qrCodeAuthValidInSeconds = 900; // = 15 minutes
